const DEFAULT_TIMEOUT = 500;

/**
 * Detect when the requestanimationframe loop pauses and resumes
 *
 * RAF loops get paused when the browser is offscreen
 *
 * @param {function(): void} onPause - Called when RAF loop pauses.
 * @param {function(): void} onResume - Called when RAF loop resumes.
 * @param {number} [timeout=500] - Timeout duration before RAF loop is considered paused
 */
export default function (onPause, onResume, timeout = DEFAULT_TIMEOUT) {
  let rafLoopIsPaused = false;

  // handleRafPause is called only when the timeout duration has elapsed
  // since the last animation frame without another animation frame
  const handleRafPause = () => {
    onPause();
    rafLoopIsPaused = true;
  };

  let timeoutID;

  const tick = () => {
    if (rafLoopIsPaused) {
      onResume();
      rafLoopIsPaused = false;
    }

    // as long as the time between animation frames is shorter than the timeout duration
    // the timeout will always be cleared before it can trigger
    clearTimeout(timeoutID);
    timeoutID = setTimeout(handleRafPause, timeout);

    requestAnimationFrame(tick);
  };
  tick();
}
